<template>
  <b-card>
    <b-button
      variant="primary"
      class="mb-1"
      @click="$bvModal.show('assign-violation')"
    >
      Assign violation
    </b-button>

    <AssignViolationModal
      v-if="violations.length"
      :driver-id="driverID"
      :violation-types="violations"
      @violation-assigned="fetchDriverViolations"
    />
    <b-row>
      <b-col md="4">
        <b-form-group label="Search by state">
          <b-form-select
            v-model="params.state"
            :options="stateOptions"
            value-field="value"
            text-field="label"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="4"
        class="d-flex align-items-center justify-content-center"
      >
        <b-button
          variant="primary"
          :disabled="!params.state"
          @click="fetchDriverViolations"
        >
          Search
        </b-button>
      </b-col>
    </b-row>
    <base-overlay :show="fetchingList">
      <b-table
        :fields="tableColumns"
        :items="driverViolations"
        empty-text="No violations for this driver"
        show-empty
      />
      <base-pagination
        v-model="params.page"
        class="mt-1"
        :total="totalViolations"
        @input="fetchDriverViolations"
        @new-per-page="params.per_page = $event;params.page = 1"
      />
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BTable, BFormSelect, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import AssignViolationModal from './AssignViolationModal.vue'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import formatDate from '@/utils/date-format'
import BasePagination from '@/UI/BasePagination.vue'
import { VIOLATIONS_ACTIONS } from '@/views/driver/violations/violations-enums'

export default {
  components: {
    BCard,
    BaseOverlay,
    BTable,
    BButton,
    AssignViolationModal,
    BasePagination,
    BFormSelect,
    BRow,
    BCol,
    BFormGroup,
  },

  setup(_, ctx) {
    const driverID = ctx.root.$route.params.id
    const tableColumns = [
      'violation_type',
      {
        label: 'state',
        key: 'state',
        formatter: val => snakeCaseToCamelCase(val),
      },
      {
        label: 'reported by',
        key: 'source',
      },
      {
        label: 'Source ID',
        key: 'description',
      },
      {
        label: 'repored at',
        key: 'created_at',
        formatter: val => formatDate(val),
      },
      {
        label: 'Zone',
        key: 'zone',
        formatter: val => val?.split('::')[1],
      },
      {
        label: 'Service',
        key: 'service_type',
        formatter: val => val?.split('::')[1],
      },
    ]
    const violations = ref([])

    const fetchViolationTypes = async () => {
      const result = await ctx.root.$store.dispatch('drivers/fetchViolationTypes')
      const { data } = result.data
      violations.value = data
    }

    const params = ref({
      page: 1,
      per_page: 10,
      state: null,
    })
    const totalViolations = ref(0)

    const fetchingList = ref(false)
    const driverViolations = ref([])
    const fetchDriverViolations = async () => {
      fetchingList.value = true
      if (violations.value.length === 0) {
        await fetchViolationTypes()
      }
      const result = await ctx.root.$store.dispatch('drivers/fetchViolationsList', {
        driver_id: driverID,
        page: params.value.page,
        per_page: params.value.per_page,
        state: params.value.state || undefined,
      })
      const { total, violations: violationResult } = result.data.data.data
      totalViolations.value = total
      driverViolations.value = violationResult.map(v => {
        if (v.violation_type) {
          const violationType = violations.value.find(t => t.id === v.violation_type)
          const violationTypeName = violationType ? violationType.name : ''
          return { ...v, violation_type: violationTypeName }
        }
        return v
      })
      fetchingList.value = false
    }

    fetchDriverViolations()

    watch(() => params.value.per_page, () => {
      fetchDriverViolations()
    })

    const stateOptions = computed(() => {
      const arr = Object.keys(VIOLATIONS_ACTIONS)
      return arr.map(el => ({ label: snakeCaseToCamelCase(el), value: el }))
    })

    return {
      stateOptions,
      fetchDriverViolations,
      driverID,
      violations,
      tableColumns,
      params,
      totalViolations,
      fetchingList,
      driverViolations,
    }
  },
}
</script>
